module.exports = __webpack_public_path__ + "static/media/left-chevron.c2d1b44f.svg";